import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

const ease = [0.22, 1, 0.36, 1];

export default function Shop() {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/collections").then((r) => setCollections(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="relative z-10 pt-36 pb-24 max-w-[1400px] mx-auto px-6 md:px-10">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease }}>
        <h1 className="font-serif text-6xl md:text-8xl font-light leading-none mb-6" data-testid="shop-title">Le collezioni</h1>
        <p className="text-lg text-muted-foreground max-w-xl">Ogni creazione nasce per custodire un'emozione, un'intenzione e un ricordo. Fiori e cristalli si intrecciano dando vita a collezioni uniche, trasformando la bellezza della natura in un gesto da conservare nel tempo.</p>
      </motion.div>

      <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16" data-testid="collections-grid">
        {loading
          ? Array.from({ length: 6 }).map((_, i) => <div key={i} className="aspect-[4/5] bg-muted rounded-md animate-pulse" />)
          : collections.map((c, i) => (
              <motion.div
                key={c.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease }}
                data-testid={`collection-card-${c.slug}`}
              >
                <Link to={`/collezione/${c.slug}`} className="group block">
                  <div className="relative overflow-hidden rounded-md bg-muted aspect-[4/5] mb-5">
                    <img src={c.cover_image} alt={c.name} className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <h3 className="font-serif text-3xl text-white leading-tight mb-1 drop-shadow-[0_1px_6px_rgba(0,0,0,0.5)]">{c.name}</h3>
                      <span className="text-white/90 text-sm inline-flex items-center gap-1 drop-shadow-[0_1px_4px_rgba(0,0,0,0.5)]">
                        {c.product_count} {c.product_count === 1 ? "articolo" : "articoli"}
                        <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                      </span>
                    </div>
                  </div>
                  {c.description && <p className="text-sm text-muted-foreground leading-relaxed">{c.description}</p>}
                </Link>
              </motion.div>
            ))}
      </div>

      {!loading && collections.length === 0 && (
        <p className="text-muted-foreground mt-10">Nessuna collezione ancora. Aggiungile dal pannello Admin.</p>
      )}
    </div>
  );
}
